export const HttpMethod = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE'
  };
  
  export const API_KEY = process.env.REACT_APP_BYTECHAT_API_KEY || 'test-key'; // ByteChat API key from env
  
  export const getBaseUrl = async () => {
     return 'https://pb.bytecrafts.in/api';
    //  return 'http://localhost:3000/api'
  };

  export const bytechatUrl = async () => {
    return 'https://bytechat.bytecrafts.in/api/v1/';
    // return 'http://localhost:8001/api/v1/';
  };